import React from 'react'
import Loader from './Loader';




//Function To show sub components
function LoaderSubComponent({ component }) {
    //const { breakPoint } = useViewport();
    const [loading, setLoading] = React.useState(true);
    //Simulate loading data 
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 0);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    if (loading) {
        return (<Loader />)
    }
    return (component);
}

export default LoaderSubComponent;







